/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable
 */
export interface JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable
     */
    couponApplicableNo?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable
     */
    relationship?: string;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable
     */
    degreeCount?: string;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable
     */
    age?: number;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable
     */
    ageType?: string;
}

export function JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicableFromJSON(json: any): JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable {
    return JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicableFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicableFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'couponApplicableNo': !exists(json, 'couponApplicableNo') ? undefined : json['couponApplicableNo'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'relationship': !exists(json, 'relationship') ? undefined : json['relationship'],
        'degreeCount': !exists(json, 'degreeCount') ? undefined : json['degreeCount'],
        'age': !exists(json, 'age') ? undefined : json['age'],
        'ageType': !exists(json, 'ageType') ? undefined : json['ageType'],
    };
}

export function JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicableToJSON(value?: JpCoBenefitoneBsdpBffInfrastructureDtoOrderCacheCouponApplicable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'couponApplicableNo': value.couponApplicableNo,
        'lastName': value.lastName,
        'firstName': value.firstName,
        'relationship': value.relationship,
        'degreeCount': value.degreeCount,
        'age': value.age,
        'ageType': value.ageType,
    };
}

